export default __webpack_public_path__ + "static/media/step1b.be989b7d.png";